// components
import XInputText from './x-input-text/x-input-text.vue';
import XInputTextArea from './x-input-text-area/x-input-text-area.vue';
import XForm from './x-form/x-form.vue';
import XCheckbox from './x-checkbox/x-checkbox.vue';
import XElement from './x-element/x-element.vue';
import XFieldset from './x-fieldset/x-fieldset.vue';
import XInputName from './x-input-name/x-input-name.vue';
import XRadios from './x-radios/x-radios.vue';
import XSubmit from './x-submit/x-submit.vue';
import XLink from './x-link/x-link.vue';
import XAnchor from './x-anchor/x-anchor.vue';
import XCheckboxList from './x-checkbox-list/x-checkbox-list.vue';
import XSelect from './x-select/x-select.vue';
import XInputDate from './x-input-date/x-input-date.vue';
import XInputMemorableDate from './x-input-memorable-date/x-input-memorable-date.vue';
import XInputAddress from './x-input-address/x-input-address.vue';
import XInputPhone from './x-input-phone/x-input-phone.vue';
import XApplicationProgressBar from './x-application-progress-bar/x-application-progress-bar.vue';
import XPayRate from './x-payrate/x-payrate.vue';
import XButton from './x-button/x-button.vue';
import XInputEmail from './x-input-email/x-input-email.vue';
import XInputTel from './x-input-tel/x-input-tel.vue';
import XTypeAhead from './x-type-ahead/x-type-ahead.vue';
import XInputCurrency from './x-input-currency/x-input-currency.vue';
import XInputNumber from './x-input-number/x-input-number.vue';
import XElementContainer from './x-element-container/x-element-container.vue';
import XCollapse from './x-collapse/x-collapse.vue';
import XSpinner from './x-spinner/x-spinner.vue';

import XFormManifest from './x-form-manifest/x-form-manifest.vue';
import XRouteContainer from './x-route-container/x-route-container.vue';
import XRoute from './x-route/x-route.vue';
import XErrorContainer from './x-error-container/x-error-container.vue';
import XError from './x-error/x-error.vue';
import XErrorList from './x-error-list/x-error-list.vue';
import XModal from './x-modal/x-modal.vue';
import XDialog from './x-dialog/x-dialog.vue';

// meta components
import XGenerator from './x-generator/x-generator.vue';
import XDynamic from './x-dynamic/x-dynamic.vue';

export default [
    XInputText,
    XInputTextArea,
    XForm,
    XCheckbox,
    XElement,
    XFieldset,
    XInputName,
    XSubmit,
    XLink,
    XAnchor,
    XRadios,
    XCheckboxList,
    XSelect,
    XInputDate,
    XInputAddress,
    XInputPhone,
    XInputCurrency,
    XInputNumber,
    XTypeAhead,
    XSpinner,
    XElementContainer,
    XFormManifest,
    XRouteContainer,
    XRoute,
    XErrorContainer,
    XError,
    XErrorList,
    XGenerator,
    XDynamic,
    XButton,
    XPayRate,
    XApplicationProgressBar,
    XCollapse,
    XInputEmail,
    XInputMemorableDate,
    XInputTel,
    XModal,
    XDialog,
];



// WEBPACK FOOTER //
// ./source/components/index.js